import React, { useState, useEffect } from 'react';
import { DirectusService } from '../services/DirectusService';

const ServerStatus: React.FC = () => {
  const [connectionStatus, setConnectionStatus] = useState<{ connected: boolean; url: string } | null>(null);
  const [isChecking, setIsChecking] = useState(false);

  const checkConnection = async () => {
    setIsChecking(true);
    try {
      const status = await DirectusService.checkConnection();
      setConnectionStatus(status);
    } catch (error) {
      setConnectionStatus({ connected: false, url: 'No connection' });
    } finally {
      setIsChecking(false);
    }
  };

  useEffect(() => {
    checkConnection();
    // Check connection every 30 seconds
    const interval = setInterval(checkConnection, 30000);
    return () => clearInterval(interval);
  }, []);

  if (connectionStatus === null) {
    return (
      <div className="flex items-center space-x-2 text-gray-400">
        <div className="w-2 h-2 bg-gray-400 rounded-full animate-pulse"></div>
        <span className="text-sm">Checking server...</span>
      </div>
    );
  }

  return (
    <div className="flex items-center space-x-2">
      <button
        onClick={checkConnection}
        disabled={isChecking}
        className="flex items-center space-x-2 hover:bg-white/10 rounded-lg px-3 py-2 transition-colors"
      >
        <div 
          className={`w-2 h-2 rounded-full ${
            connectionStatus.connected 
              ? 'bg-green-500 animate-pulse' 
              : 'bg-red-500'
          }`}
        ></div>
        <span className="text-sm text-gray-300">
          {connectionStatus.connected ? connectionStatus.url : 'Server Offline'}
        </span>
        {isChecking && (
          <svg className="w-4 h-4 animate-spin text-gray-400" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        )}
      </button>
    </div>
  );
};

export default ServerStatus;
